import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { com } from '@eidu/form'
import { findFieldById } from '../../util/EntityTypeExtensions'
import Field = com.eidu.sharedlib.entity.field.Field
import fieldIdFromString = com.eidu.sharedlib.entity.field.fieldIdFromString

type FieldSingleSelectProps = {
  label: string
  options: readonly Field[]
  selected: Field | undefined
  setSelected: (field: Field) => void
  entityType: com.eidu.sharedlib.entity.type.EntityType
  errorLabel?: string
  disabled?: boolean
}

const FieldSingleSelect = ({
  label,
  options,
  selected,
  setSelected,
  entityType,
  errorLabel = 'No fields found',
  disabled = false,
}: FieldSingleSelectProps) =>
  options.length > 0 ? (
    <FormControl sx={{ minWidth: 200 }} disabled={disabled}>
      <InputLabel id="field-label-id">{label}</InputLabel>
      <Select
        labelId="field-label-id"
        value={selected?.id.toString() ?? ''}
        disabled={disabled}
        label={label}
        onChange={(event) => {
          const selectedField = findFieldById(entityType, fieldIdFromString(event.target.value))
          if (selectedField) {
            setSelected(selectedField)
          }
        }}
      >
        {options.map((entityField) => (
          <MenuItem key={entityField.name} value={entityField.id.toString()}>
            {entityField.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : (
    <Typography variant="body2" color="error">
      {errorLabel}
    </Typography>
  )

export default FieldSingleSelect
